<template>
  <v-container style="max-width: 100%">
    <v-row no-gutters>
      <v-col>
        <h1>{{ $t("sites.title") }}</h1>
        <email-confirmation-reminder/>
        <v-progress-linear
            indeterminate
            reverse
            v-show="!isFetchedSites"
            class="my-2"
        ></v-progress-linear>
        <v-btn color="success" small @click="newSiteWindow.isVisible = !newSiteWindow.isVisible" :disabled="!is_email_confirmed">
          <v-icon small left>mdi-plus</v-icon>
          {{ $t("sites.add_site") }}
        </v-btn>
        <v-expansion-panels class="mt-2" v-model="panel" multiple>
          <v-expansion-panel v-for="site in sites" :key="site.id">
            <v-expansion-panel-header><h4>{{
              site.domain
              }}</h4></v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-progress-linear
                indeterminate
                reverse
                v-if="nowProcessingSiteWithId === site.id"
              ></v-progress-linear>
              <v-btn :to="{ name: 'Catalogs_groups', params: { 'site_id': site.id }}" color="primary" class="mr-2 mb-2">
                <v-icon left>mdi-format-list-bulleted</v-icon>
                {{ $t("catalogs_groups.title") }}
              </v-btn>
              <v-btn :to="{ name: 'Payments', params: { 'site_id': site.id }}"  color="primary" class="mb-2">
                <v-icon left>mdi-cash-100</v-icon>
                {{ $t("payments.title") }}
              </v-btn>
              <v-divider class="mt-3"/>
              <v-list subheader three-line>
                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-title>{{
                      $t("sites.domain")
                    }}</v-list-item-title>
                    <v-list-item-subtitle
                      ><a target="_blank" :href="site.protocol + site.domain"
                        >{{ site.domain }}
                      </a></v-list-item-subtitle
                    >
                  </v-list-item-content>
                </v-list-item>
                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-title>{{
                      $t("sites.identifier")
                    }}</v-list-item-title>
                    <v-list-item-subtitle>{{
                      site.sait_code
                    }}</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-title>{{
                      $t("sites.landing_page")
                    }}</v-list-item-title>
                    <v-list-item-subtitle class="py-2"
                      >{{ site.protocol }}{{ site.domain
                      }}<span class="red--text">{{
                        site.target_url
                      }}</span></v-list-item-subtitle
                    >
                    <v-list-item-title>
                      <v-btn
                        elevation="0"
                        x-small
                        color="warning"
                        @click="showLandingPageWindow(site)"
                        ><v-icon x-small left>mdi-pencil</v-icon
                        >{{ $t("common.edit") }}</v-btn
                      >
                      <v-btn
                        class="ml-1"
                        elevation="0"
                        x-small
                        color="success"
                        target="_blank"
                        :href="
                          site.protocol +
                          site.domain +
                          site.target_url
                            .replace('*brand*', 'bremi')
                            .replace('*part_number*', '12345')
                        "
                        ><v-icon x-small left>mdi-open-in-new</v-icon
                        >{{ $t("common.test") }}</v-btn
                      >
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-list>
              <v-divider></v-divider>
              <v-list>
                <v-list-item>
                  <v-list-item-action>
                    <v-switch
                      v-model="site.shapka_enable"
                      @change="update(site)"
                    ></v-switch>
                  </v-list-item-action>
                  <v-list-item-content>
                    <v-list-item-title>{{
                      $t("sites.catalog_header")
                    }}</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
                <v-list-item>
                  <v-list-item-action>
                    <v-switch
                      v-model="site.title_enable"
                      @change="update(site)"
                    ></v-switch>
                  </v-list-item-action>
                  <v-list-item-content>
                    <v-list-item-title>{{
                      $t("sites.catalog_title")
                    }}</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
                <v-list-item>
                  <v-list-item-action>
                    <v-switch
                      v-model="site.bread_crumbs_enable"
                      @change="update(site)"
                    ></v-switch>
                  </v-list-item-action>
                  <v-list-item-content>
                    <v-list-item-title>{{
                      $t("sites.breadcrumbs")
                    }}</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>

                <v-list-item>
                  <v-list-item-action>
                    <v-switch
                      v-model="site.bread_crumbs_short"
                      @change="update(site)"
                    ></v-switch>
                  </v-list-item-action>
                  <v-list-item-content>
                    <v-list-item-title>{{
                      $t("sites.link_to_site_in_breadcrumbs")
                    }}</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-list>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </v-col>
    </v-row>
    <landing-page-window
      @save="(site) => update(site)"
      :saving-in-progress="savingInProgress"
      :is-visible="landingPageWindow.isVisible"
      :site="landingPageWindow.site"
      @hide="
        landingPageWindow.site = null;
        landingPageWindow.isVisible = false;
      "
    ></landing-page-window>
    <site-window
      @store="site=>store(site)"
      :saving-in-progress="savingInProgress"
      :is-visible="newSiteWindow.isVisible"
      @hide="
        newSiteWindow.isVisible = false;
      "
    ></site-window>
  </v-container>
</template>
<script>
import { mapFields } from "vuex-map-fields";
import LandingPageWindow from "@/components/LandingPageWindow";
import SiteWindow from "@/components/SiteWindow";
import EmailConfirmationReminder from "../components/EmailConfirmationReminder.vue";

export default {
  name: "Sites",
  components: {EmailConfirmationReminder, SiteWindow, LandingPageWindow },
  data: () => ({
    panel: [],
    newSiteWindow:{
      isVisible: false,
    },
    landingPageWindow: {
      isVisible: false,
      site: null,
    },
  }),
  mounted() {
    this.$store.dispatch("sites/fetch");
  },
  computed: {
    ...mapFields("auth", [
      "is_email_confirmed"
    ]),
    ...mapFields("sites", [
      "nowProcessingSiteWithId",
      "sites",
      "fetched",
      "savingInProgress",
      "isFetchedSites",
    ]),
  },
  methods: {
    update(site) {
      this.$store.dispatch("sites/update", site).then((updated) => {
        if (updated) {
          this.landingPageWindow.isVisible = false;
        }
      });
    },
    store(site) {
      this.$store.dispatch("sites/store", site).then((created) => {
        if (created) {
          this.newSiteWindow.isVisible = false;
        }
      });
    },
    showLandingPageWindow(site) {
      this.landingPageWindow.isVisible = true;
      this.landingPageWindow.site = site;
    },
  },
  watch: {
    sites() {
      for (let i in this.sites) {
        this.panel.push(parseInt(i));
      }
    },
  },
};
</script>
